import React from "react"
import { PebbleTable } from "../../ui/TableComponents";
import picturePlaceHolder from "../../../assets/images/picture_placeholder.svg"

const Contributors = ({ userDetails }) => {
    const columns = [
        {
            header: "",
            key: "image",
            type: "image",
        },
        {
            header: "Name",
            key: "name",
            type: "compound",
            primaryKey: "name",
            secondaryKey: "email",
            underlinePrimary: true,
            secondaryStyles: "text-[12px] whitespace-nowrap",
        },
        {
            header: "Access Level",
            key: "accessLevel",
            type: "text",
        },
        {
            header: "Event",
            key: "event",
            type: "text",
        },
        {
            header: "",
            key: "action",
            type: "text",
        },
    ];
    const data = [
        {
            name: userDetails?.fullName,
            image: userDetails?.companyLogo || picturePlaceHolder,
            email: userDetails?.userEmail,
            accessLevel: "Administrator"
        }
    ]
    return (
        <div className="w-full p-6 !pt-0">
            <p className="mb-7 pl-1 pr-1 sm:pr-8 sm:pl-8 text-xl font-medium text-grey-900">
                Add Contributors
            </p>
            <PebbleTable
                columns={columns}
                data={data}
            />
            <p className="text-xs lg:ml-8 mt-4">
                Contributors are only available in Pebble Pro plans and above (coming soon!).
            </p>
        </div>
    )
}

export default Contributors
